interface SkeletonTableProps {
  rows?: number;
  cols?: number;
}

export function SkeletonTable({ rows = 6, cols = 5 }: SkeletonTableProps) {
  return (
    <div className="w-full overflow-hidden rounded-lg border border-border">
      {/* Header */}
      <div className="flex border-b border-border bg-muted/40 px-4 py-3 gap-4">
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="skeleton-shimmer h-4 rounded" style={{ flex: i === 0 ? 2 : 1 }} />
        ))}
      </div>
      {/* Rows */}
      {Array.from({ length: rows }).map((_, row) => (
        <div
          key={row}
          className="flex items-center gap-4 border-b border-border px-4 py-3 last:border-0"
        >
          {Array.from({ length: cols }).map((_, col) => (
            <div
              key={col}
              className="skeleton-shimmer h-4 rounded"
              style={{ flex: col === 0 ? 2 : 1, height: col === 0 ? 16 : 14 }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
